import React from 'react';

import axios from 'axios';

import API from 'utils/api';
import { RiskActionDetail } from 'utils/api/modules/risks';

interface RiskActionState {
  data: RiskActionDetail | null;
  failed: boolean;
}

export const useRiskAction = (
  uuid: string
): RiskActionState & { setData: (data: RiskActionDetail) => void; reload: () => void } => {
  const [state, setState] = React.useState<RiskActionState>({ data: null, failed: false });
  const [version, setVersion] = React.useState(0);

  React.useEffect(() => {
    const source = axios.CancelToken.source();
    setState((current) => (current.data?.uuid === uuid ? current : { data: null, failed: false }));
    API.risks
      .loadRiskAction(uuid, source)()
      .then(({ data }) => {
        setState({ data, failed: false });
      })
      .catch((error: unknown) => {
        if (!axios.isCancel(error)) setState({ data: null, failed: true });
      });
    return () => source.cancel();
  }, [uuid, version]);

  return {
    ...state,
    setData: (data) => setState({ data, failed: false }),
    reload: () => setVersion((current) => current + 1),
  };
};
